export default __webpack_public_path__ + "static/media/landscape11.786f24a2.jpg";